import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {TourService} from '../services/tour.service';
import {TourApiService} from '../services/tour-api.service';
import {Scene} from '../model/scene';
import {EnumAware} from '../decorators/enum-aware.decorator';
import {ModalService} from '../services/modal.service';
import {TrackingService} from '../services/tracking.service';
import {OptionGroup} from '../model/option-group';
import {Subscription} from 'rxjs/Subscription';
import {OptionDetailService} from '../services/option-detail.service';

@Component({
  selector: 'gt-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css', './tour.component.css']
})
@EnumAware
export class FeaturesComponent implements OnInit, OnDestroy {

  sceneLabels: string[];
  currentScene: Scene;
  sceneLoadedSubscription: Subscription;
  constructor(public apiService: TourApiService,
              public modalService: ModalService,
              private tourService: TourService,
              private trackingService: TrackingService,
              public optionDetailService: OptionDetailService) { }

  ngOnInit() {
    this.tourService.setDocumentTitleWithTour(this.tourService.tourFeatureTitle('features'));

    if (this.tourService.optionsAvailable) {
      this.setSceneLabels();
    }
    this.sceneLoadedSubscription = this.apiService.sceneOptionsLoaded.subscribe(
      (loaded: boolean) => {
        if (loaded) {
          this.setSceneLabels();
        }
      }
    );
  }

  setSceneLabels() {
    this.sceneLabels = this.tourService.getSceneLabels(true);
    if (!this.currentScene) {
      this.currentScene = this.tourService.tour.findSceneByDisplayName(this.sceneLabels[0]);
    }
  }

  showFeaturesForScene(sceneName: string) {
    this.currentScene = this.tourService.tour.findSceneByDisplayName(sceneName);
    this.trackingService.trackAction(TrackingService.kActionGoToScene, sceneName, 0);
  }

  toggleOptionsGroup(group: OptionGroup) {
    group.expanded = !group.expanded;
  }

  ngOnDestroy() {
    if (this.sceneLoadedSubscription != null) {
      this.sceneLoadedSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/features.component.ts